module.exports = __webpack_public_path__ + "media/images/restricciones-5c1beb83b943719d840d579f3dd77feb.png";